export default __webpack_public_path__ + "static/media/unsplash-3.ad504e7b.jpg";